import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLEAR_AUDIO_TRANSLATION, SET_AUDIO_TRANSLATION_LANGUAGE, SET_PARTICIPANT_AUDIO_TRANSLATION_LANGUAGE } from './actionTypes';
const DEFAULT_STATE = {
    language: null,
    participantLanguages: {}
};
ReducerRegistry.register('features/audio-translation', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CLEAR_AUDIO_TRANSLATION:
            return DEFAULT_STATE;
        case SET_AUDIO_TRANSLATION_LANGUAGE:
            return {
                ...state,
                language: action.language
            };
        case SET_PARTICIPANT_AUDIO_TRANSLATION_LANGUAGE:
            return {
                ...state,
                participantLanguages: {
                    ...state.participantLanguages,
                    [action.participantId]: action.language
                }
            };
        default:
            return state;
    }
});
